import React, { useState } from 'react';
import { Box, Container, Grid, Tab, Tabs, Typography } from '@mui/material';
import Colors from '../../utils/Colors';
import ProjectCard from '../../components/ProjectCard/ProjectCard';
import { useQuery } from '@tanstack/react-query';
import { getObjects } from '../../api/Api';
import SkeletonLoading from '../../components/SkeletonLoading/SkeletonLoading';
import { MetaTags } from 'react-meta-tags';
import NotFoundData from '../../components/NoteFoundData/NotFoundData';

const Project = () => {
    // start tabs
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // filter
    const [filter, setFilter] = useState('');
    // fetch the services data
    const { data: servicesData } = useQuery(['services'], () =>
        getObjects('service')
    );

    // fetch the project data
    const { data, isError, isLoading, isSuccess } = useQuery(
        ['project', filter],
        () => getObjects('project', filter ? `&service=${filter}` : undefined),
        {
            keepPreviousData: true,
        }
    );
    if (isError) {
        return <Typography>Occurred an error</Typography>;
    }
    if (isLoading) {
        return <SkeletonLoading />;
    }
    if (isSuccess) {
        return (
            <Box>
                <MetaTags>
                    <title>Afghan cosmos - Project</title>
                    <meta name="description" content="Brows our Project page" />
                </MetaTags>
                {/* Start Tabs */}
                <Box
                    sx={{
                        width: '100vw',
                        bgcolor: 'background.paper',
                        overflowX: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        textColor="primary"
                        indicatorColor="primary"
                        TabIndicatorProps={{
                            sx: { height: 4, backgroundColor: '#1976d2' },
                        }}
                        sx={{
                            width: { xs: '100vw', md: '80vw' },
                            mx: 'auto',
                            '& .MuiTabs-flexContainer': {
                                justifyContent: {
                                    xs: 'flex-start',
                                    md: 'center',
                                },
                            },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                                flexShrink: 0,
                            },
                            '& .Mui-selected': { color: '#1976d2' },
                        }}
                    >
                        <Tab label="All" onClick={() => setFilter(null)} />

                        {servicesData?.length > 0 ? (
                            servicesData.map((service) => (
                                <Tab
                                    key={service.id}
                                    label={service.name}
                                    onClick={() => setFilter(service.id)}
                                />
                            ))
                        ) : (
                            <Tab label="No Data" />
                        )}
                    </Tabs>
                </Box>

                {/* End Tabs */}
                <Box
                    sx={{
                        height: '400px',
                        backgroundColor: Colors.SECTION_BACKGROUND_COLOR,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            width: { xl: '50%', lg: '50%', xs: '80%' },
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 3,
                        }}
                    >
                        <Typography
                            variant="h4"
                            fontWeight={'bold'}
                            sx={{
                                textAlign: 'center',
                                color: Colors.PRIMARY,
                                fontSize: { xl: '45px', xs: '30px' },
                            }}
                        >
                            Successfully Completed Projects
                        </Typography>
                        <Box>
                            <Typography sx={{ textAlign: 'center' }}>
                                Successfully Completed Projects, honors our
                                team's perseverance and commitment to finishing
                                a range of projects.
                            </Typography>
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    mt: { xl: 0, lg: 0, md: 0, sm: 2, xs: 2 },
                                }}
                            >
                                These achievements show our dedication to
                                excellence and our capacity for overcoming
                                obstacles to succeed.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Container sx={{ mt: 5 }}>
                    {data.length === 0 ? (
                        <NotFoundData type="project" />
                    ) : (
                        <Grid container rowSpacing={3}>
                            {data.map((item, index) => (
                                <Grid
                                    key={index}
                                    item
                                    xl={12}
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                >
                                    <ProjectCard data={item} />
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Container>
            </Box>
        );
    }
};

export default Project;
